import { render, staticRenderFns } from "./SysRole.vue?vue&type=template&id=4caa6248&scoped=true"
import script from "./SysRole.vue?vue&type=script&lang=js"
export * from "./SysRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa6248",
  null
  
)

export default component.exports